import { Card, CardContent } from "@/components/ui/card";
import { QuarterZipPreview } from "@/components/quarter-zip-preview";

interface PreviewStepProps {
  raceCounts: {
    long: number;
    middle: number;
    olympic: number;
    sprint: number;
    other: number;
  };
}

export function PreviewStep({ raceCounts }: PreviewStepProps) {
  return (
    <Card>
      <CardContent className="p-6">
        <div className="space-y-4">
          <h2 className="text-2xl font-bold font-spartan">
            Preview Your Design
          </h2>
          <p className="text-gray-500">
            Here's how your personalized quarter zip will look with your race
            achievements.
          </p>
          <div className="flex justify-center py-6">
            <QuarterZipPreview races={raceCounts} />
          </div>
          <div className="rounded-lg bg-gray-50 p-4 mt-4">
            <p className="text-sm text-gray-500">
              By proceeding to checkout, you agree that we will verify your race
              achievements before producing your personalized quarter zip. You
              can upload proof of your races after checkout.
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
